// extracted by mini-css-extract-plugin
export default {"box":"Loading_box__-uJFk"};